/**
 * UUID v4 that works outside a secure context.
 *
 * `crypto.randomUUID` is only defined when the page is served from HTTPS or
 * `localhost`. The portal is routinely opened over plain http on a LAN address
 * (a device on the same network, an IP or a *.nip.io host), where the function is
 * undefined and calling it throws before any request is sent.
 *
 * `crypto.getRandomValues` has no such restriction, so it backs this fallback.
 * These ids are opaque correlation keys for progress streams, never secrets.
 */
export function newUuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);
  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }

  // RFC 4122 version and variant bits.
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0'));
  return [
    hex.slice(0, 4).join(''),
    hex.slice(4, 6).join(''),
    hex.slice(6, 8).join(''),
    hex.slice(8, 10).join(''),
    hex.slice(10, 16).join(''),
  ].join('-');
}
